import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of, switchMap, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.isLoggedIn$.pipe(
      take(1),
      switchMap((isLoggedIn) => {
        if (isLoggedIn) {
          return of(true);
        } else {
          const returnAfterAuth = route.data['returnAfterAuth'];

          if (returnAfterAuth === false) {
            return of(this.router.createUrlTree(['auth', 'login']));
          }

          return of(this.router.createUrlTree(['auth', 'login'], { queryParams: { returnUrl: btoa(state.url) } }));
        }
      })
    );
  }
}
